import { render, staticRenderFns } from "./CreateDispute.htm?vue&type=template&id=7b994f36&scoped=true&"
import script from "./CreateDispute.ts?vue&type=script&lang=js&"
export * from "./CreateDispute.ts?vue&type=script&lang=js&"
import style0 from "./CreateDispute.scss?vue&type=style&index=0&id=7b994f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b994f36",
  null
  
)

export default component.exports